<template>
  <div class="modalWrapper">
    <div class="modalBlock">
      <div class="actionHeadline">
        {{
          getTranslation(
            $store,
            "Product",
            "display_name",
            product.id,
            product.name
          )
        }}
      </div>
      <div class="actionSubline">
        {{
          getTranslation(
            $store,
            "ProductExtra",
            "question_text",
            currentExtra.id,
            currentExtra.question_text
          )
        }}
      </div>
      <ListOverflowScroll
        ref="listOverflowScroll"
        :maxListHeight="maxListHeight"
      >
        <ItemList
          itemType="extra"
          :itemsToShow="currentExtras"
          :animate="false"
          @onItemClicked="confirm"
          :style="itemListStyle(currentExtras)"
        ></ItemList>
      </ListOverflowScroll>
      <div class="actionsBlock">
        <div class="confirmBtn" @click="close">
          {{ $t("dialog.extra.btn.deny") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getTranslation, itemListStyle } from "@/utils/helpers";
import ListOverflowScroll from "@/components/common/ListOverflowScroll";
import { mapGetters } from "vuex";
import {
  activeExtras,
  getProductExtrasByDeliveryMethod,
  sortExtras
} from "@/utils/products";
import ItemList from "@/components/common/ItemList.vue";
export default {
  components: {
    ListOverflowScroll,
    ItemList
  },
  computed: {
    ...mapGetters({
      selectedDeliveryMethod: "SELECTED_DELIVERY_METHOD",
      getExtras: "EXTRAS"
    }),
    currentExtra() {
      //get Extra Category
      let extra_list = [...this.productExtrasByDeliveryMethod];
      extra_list.sort((e1, e2) => {
        if (e1.order_by === e2.order_by) return e1.name < e2.name ? -1 : 1;
        return e1.order_by - e2.order_by;
      });
      let to_edit = extra_list.find(
        e1 =>
          typeof this.extras.find(e2 => e1.id === e2.extra_category_id) ===
          "undefined"
      );
      return to_edit;
    },
    currentExtras() {
      //get extras in category
      let extras = [...this.currentExtra.extras];
      extras.forEach(extra => {
        let global_extra = this.getExtras[extra.id];
        if (!global_extra) {
          console.error("Extras missmatch!");
          extra.hide = true;
        } else {
          extra.soldout = global_extra.soldout;
          extra.hide = global_extra.hide;
        }
      });
      let filtered_extras = extras.filter(extra => !extra.hide);
      let extras_ordered = filtered_extras.sort((ee1, ee2) => {
        if (ee1.order_by === ee2.order_by) return ee1.name < ee2.name ? -1 : 1;
        return ee1.order_by - ee2.order_by;
      });
      let extras_ordered_active = activeExtras(
        extras_ordered,
        this.selectedDeliveryMethod
      );
      return extras_ordered_active;
    }
  },
  created() {
    this.productExtrasByDeliveryMethod = getProductExtrasByDeliveryMethod(
      this.product.extras,
      this.selectedDeliveryMethod
    );
    if (typeof this.product.selectedExtras !== "undefined") {
      this.extras = this.product.selectedExtras; //prepopulate on edit
    }
  },
  data() {
    return {
      productExtrasByDeliveryMethod: [],
      extras: [],
      maxListHeight: 1000
    };
  },
  props: {
    product: Object
  },
  methods: {
    itemListStyle,
    getTranslation,
    close() {
      this.$emit("onClose");
    },
    confirm(extra) {
      if (extra.soldout) return;

      setTimeout(this.$refs.listOverflowScroll.checkOverflown, 0);
      let new_extra = { ...extra, extra_category_id: this.currentExtra.id };
      this.extras.push(new_extra);
      sortExtras(this.product, this.extras);
      if (this.extras.length === this.productExtrasByDeliveryMethod.length) {
        this.$emit("onConfirm", this.extras);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.modalWrapper {
  display: flex;
  height: 100vh;
  width: 100vw;
  position: fixed;
  z-index: 1300;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0;
  padding: 0;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
}

.modalBlock {
  z-index: 1300;
  display: flex;
  align-self: center;
  flex-direction: column;
  text-align: center;
  min-height: 550px;
  padding: 50px 60px;
  width: 95vw;
  color: black;
  justify-content: space-between;
  border-radius: var(--component_modals_selectExtra_modalBlock_border-radius);
  background: var(--component_modals_selectExtra_modalBlock_background);
  box-shadow: 0 0 50px #00000029;
}
.confirmBtn {
  width: 210px;
  height: 70px;
  color: var(--component_modals_selectExtra_confirmBtn_color);
  letter-spacing: 1.84px;
  text-transform: var(--component_modals_selectExtra_confirmBtn_text-transform);
  font-family: var(--component_modals_selectExtra_confirmBtn_font-family);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--component_modals_selectExtra_confirmBtn_font-size);
  border: var(--component_modals_selectExtra_confirmBtn_border);
  border-radius: var(--component_modals_selectExtra_confirmBtn_border-radius);
  opacity: 1;
  padding: var(--component_modals_selectExtra_confirmBtn_padding);
}
.actionsBlock {
  width: 100%;
  margin-top: 50px;
  display: flex;
  justify-content: center;
}
.actionHeadline {
  text-transform: var(
    --component_modals_selectExtra_actionHeadline_text-transform
  );
  color: var(--component_modals_selectExtra_actionHeadline_color);
  font-family: var(--component_modals_selectExtra_actionHeadline_font-family);
  font-size: var(--component_modals_selectExtra_actionHeadline_font-size);
}
.actionSubline {
  margin-top: 15px;
  margin-bottom: 30px;
  color: var(--component_modals_selectExtra_actionSubline_color);
  font-family: var(--component_modals_selectExtra_actionSubline_font-family);
  font-size: var(--component_modals_selectExtra_actionSubline_font-size);
}
</style>
